export const instrumentationActionType = {
    Mouse: "Mouse",
    EnterKey: "EnterKey",
    Type: "Type",
    Expand: "Expand",
    Collapse: "Collapse"
};
